import { HTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/utils';

interface GlassCardProps extends HTMLAttributes<HTMLDivElement> {
  glow?: 'blue' | 'purple' | 'none';
  hover?: boolean;
}

const GlassCard = forwardRef<HTMLDivElement, GlassCardProps>(
  ({ className, glow = 'none', hover = false, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'bg-navy-900/60 backdrop-blur-xl border border-white/10 rounded-xl p-6 shadow-xl',
          glow === 'blue' && 'glow-blue',
          glow === 'purple' && 'glow-purple',
          hover && 'hover-lift hover:border-primary-500/30',
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);
GlassCard.displayName = 'GlassCard';

export { GlassCard };
